import { VideoAccess } from "./camera-detection-constants";

const AccessRequester = (
    setVideoAccess: (videoAccess: VideoAccess) => void,
    setIsLoading: (isLoading: boolean) => void
) => async () => {
    setIsLoading(true);
    console.log("Request access");
    try {
        const stream = await navigator.mediaDevices.getUserMedia({
            video: true
        });
        stream.getTracks().forEach(t => t.stop());
        setVideoAccess(VideoAccess.Granted);
        console.log("Access granted");
    } catch (error) {
        setVideoAccess(VideoAccess.Denied);
        console.log("Access rejected");
    }
    setIsLoading(false);
};

export default AccessRequester;
